<template lang="pug">
v-dialog(v-model="show" persistent max-width="500px" :fullscreen="$vuetify.breakpoint.smAndDown" )
    v-card.d-flex.flex-column
        v-card-title.headline {{ $t('boarderArchiveDialog.dialogTitle') }}
        v-card-text.flex-shrink-0.flex-grow-1.card-body(:style="cardBodyStyle")
            v-list
                v-list-item(v-for="(boarder, idx) in currentBoarderList" :key="idx" @click="")
                    v-list-item-action
                        v-checkbox(v-model="boarder.isSelected" on-icon="fas fa-check-square" off-icon="fal fa-square")
                    v-list-item-content.flex-shrink-0.flex-md-grow-1 {{ formatBoarderName(boarder) }}
                    v-list-item-action(v-if="operationResult")
                        v-icon(:color="getResultIconColor(boarder)") {{ getResultIcon(boarder) }}

        v-divider
        v-card-actions
            v-spacer
            template(v-if="operationResult")
                v-btn(color="primary" @click="onCloseButtonClick") {{ $t('boarderArchiveDialog.finishButtonLabel') }}
            template(v-else)
                v-btn(color="primary" @click="onSubmitButtonClick" :disabled="isSubmitButtonDisabled" :loading="isSaveInProgress") {{ submitButtonLabel }}
                v-btn(text :disabled="isSaveInProgress" @click="onCloseButtonClick") {{ $t('boarderArchiveDialog.cancelButtonLabel') }}

</template>

<script lang="ts">
import Vue from 'vue'
import { BoarderResponse } from '@/types/service-response'
import { Component, Prop } from 'vue-property-decorator'
import { BoarderArchivePayload, BoarderOptOutPayload } from '@/types/payload'
import _ from 'lodash'
import { BoarderSelectableListItem } from '@/types'
import { Action } from 'vuex-class'
import { BOARDER_ARCHIVE, } from '@/store/action-types'

@Component({})
export default class BoarderDetailDialog extends Vue {
  @Prop({ type: Boolean, default: false }) readonly show!: boolean
  @Prop({ type: Array, required: true }) readonly boarderList!: BoarderResponse[]

  private currentBoarderList: BoarderSelectableListItem[] = []
  private isSaveInProgress: boolean = false
  private operationResult: BoarderResponse[] | null = null

  @Action(BOARDER_ARCHIVE) performBoarderArchivation!: { (payload: BoarderArchivePayload): Promise<BoarderResponse[]> }

  get submitButtonLabel (): string {
    const count = this.currentBoarderList.filter((b: BoarderSelectableListItem) => b.isSelected).length

    return this.$tc('boarderArchiveDialog.submitButtonLabel', count, { count })
  }

  get isSubmitButtonDisabled (): boolean {
    return this.currentBoarderList.filter((b) => b.isSelected).map((b) => b.boarder.id).length === 0
  }

  get cardBodyStyle(): Object
  {
    if (this.$vuetify.breakpoint.smAndDown) {
      return {
        height: '0px'
      }
    } else if (this.$vuetify.breakpoint.mdOnly && window.screen.height <= 600) {
      return {
        maxHeight: '400px'
      }
    }

    return {
      maxHeight: '500px'
    }
  }

  formatBoarderName (boarder: BoarderOptOutPayload): string {
    return `${boarder.boarder.person.firstName} ${boarder.boarder.person.familyName}`
  }

  getResultIcon (boarder: BoarderSelectableListItem): string {
    if (this.operationResult?.find((b) => b.id === boarder.boarder.id)) {
      return 'far fa-check-circle'
    }

    return 'far fa-exclamation-circle'
  }

  getResultIconColor (boarder: BoarderSelectableListItem): string {
    if (this.operationResult?.find((b) => b.id === boarder.boarder.id)) {
      return 'green'
    }

    return 'warning'
  }

  async onSubmitButtonClick (): Promise<void> {
    const payload: BoarderArchivePayload = {
      boarderIdList: this.currentBoarderList.filter((b) => b.isSelected).map((b) => b.boarder.id)
    }

    this.isSaveInProgress = true

    this.operationResult = await this.performBoarderArchivation(payload)

    this.isSaveInProgress = false
  }

  onCloseButtonClick (): void {
    this.$emit('close', this.operationResult !== null)
  }

  mounted (): void {
    this.currentBoarderList = _.cloneDeep(this.boarderList)
      .sort((a, b) => a.person.familyName.localeCompare(b.person.familyName))
      .map((b: BoarderResponse): BoarderSelectableListItem => {
        return {
          boarder: b,
          isSelected: true
        }
      })
  }
}

</script>

<style lang="stylus" scoped>
.card-body
    overflow auto

</style>
